import { Star } from "@phosphor-icons/react";

export function StarBadge({ rating, count, size = 14 }) {
  if (!count) {
    return <span className="text-xs text-neutral-400">No reviews yet</span>;
  }
  return (
    <span className="inline-flex items-center gap-1 text-xs" data-testid="star-badge">
      <Star size={size} weight="fill" className="text-neutral-900"/>
      <span className="font-medium">{rating?.toFixed(1)}</span>
      <span className="text-neutral-500">({count})</span>
    </span>
  );
}

export function StarRow({ value, size = 16, onChange, testIdPrefix = "star" }) {
  const readOnly = !onChange;
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          data-testid={`${testIdPrefix}-${n}`}
          onClick={() => onChange && onChange(n)}
          disabled={readOnly}
          className={readOnly ? "cursor-default" : "cursor-pointer"}
        >
          <Star
            size={size}
            weight={n <= value ? "fill" : "regular"}
            className={n <= value ? "text-neutral-900" : "text-neutral-300"}
          />
        </button>
      ))}
    </div>
  );
}
